// extracted by mini-css-extract-plugin
export default {"modalWrapper":"CreateDispatchModal_modalWrapper__C9feg","tips":"CreateDispatchModal_tips__a1HnB","btn":"CreateDispatchModal_btn__N4CnS"};